/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploadfailed1Inputs */

const en_uploadfailed1 = /** @type {(inputs: Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed.`)
};

const pt_uploadfailed1 = /** @type {(inputs: Uploadfailed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no carregamento.`)
};

/**
* | output |
* | --- |
* | "Upload failed." |
*
* @param {Uploadfailed1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const uploadfailed1 = /** @type {((inputs?: Uploadfailed1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploadfailed1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploadfailed1(inputs)
	return pt_uploadfailed1(inputs)
});
export { uploadfailed1 as "uploadFailed" }